<template>
  <modal title="" width="45" :showModal="showModal" @close-modal="closeModal">
    <div class="px-8 flex flex-col gap-4">
      <div class="flex justify-center">
        <img
          src="@/assets/images/booking-management/shipping-cart.png"
          alt="shipping cart"
        />
      </div>
      <div class="flex justify-center mt-4">
        <h1 class="text-2xl font-semibold">Book new shipment</h1>
      </div>
      <div class="flex justify-center mt-4">
        <p>Who are you booking this shipment for?</p>
      </div>
      <div class="flex flex-row justify-around mt-1">
        <radio-input
          label="For Self"
          v-model="forSelf"
          id="self"
          :value="true"
        ></radio-input>
        <radio-input
          label="For Others"
          v-model="forSelf"
          id="other"
          :value="false"
        ></radio-input>
      </div>
      <div>
        <div class="mt-6 flex items-center justify-between">
          <label v-if="forSelf == false" for="">Search by name, Email or MuleEx ID</label>
          <label v-if="forSelf == true" for="">Shipping Address</label>
          <base-checkbox
            v-if="forSelf == false"
            label="New User"
            trueValue="new-delivery-address"
            falseValue=""
            v-model="deliveryAddress"
          />
       
        </div>

        <el-select
        :disabled="deliveryAddress !== '' || forSelf == true"
          v-model="selectedTakeoffLocationId"
          :placeholder="forSelf ? userAddress.name : 'Search Shipping Address'"
        >
          <template v-if="addresses.length > 0">
            <el-option
            
              v-for="location in addresses"
              :key="location.id"
              :label="location.contactName ? location.contactName : 'N/A'"
              :value="location.id"
            >
            </el-option>
          </template>
          <template v-else>
            <el-option>
              <loader />
            </el-option>
          </template>
        </el-select>
      </div>

      <div class="flex items-center justify-center">
        <base-button
          :disabled="disableContinuation"
          text="Continue"
          :loading="loading"
          @click="submit"
        />
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  props: {
    showModal: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      forSelf: true,
      addresses: [],
      address: "",
      selectedTakeoffLocationId: "",
      shipment: "",
      login:'',
      deliveryAddress: "",
      consigneeCount: "",
      destinationType: "",
      requestLoading: false,
      loading: false,
      userAddress : {}
    };
  },
  watch: {
    deliveryAddress(val) {
      if (val) {
        this.selectedTakeoffLocationId = "";
      }
    },
  },
  computed: {
    disableContinuation() {
      if (
        this.deliveryAddress != "" ||
        this.selectedTakeoffLocationId != "" ||
        this.forSelf == true
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    submit() {
      this.loading = true;
      
      let selectedTakeoffLocation = "";
      
      if (this.forSelf === true) {
        let loggedInUser = JSON.parse(localStorage.getItem("loggedInUser"))
        console.log(JSON.stringify(loggedInUser, null, 2))
       
        
        let data = {
          orgId:loggedInUser.orgId,
          contactName: `${loggedInUser.firstname} ${loggedInUser.middlename? loggedInUser.middlename : ''} ${loggedInUser.lastname} `,
          email: loggedInUser.email,
          mobile: loggedInUser.mobile_no,
          customerType: null,
          address: this.userAddress
        }
        selectedTakeoffLocation = data;
      } else {
        selectedTakeoffLocation = this.addresses.find((location) => {
          return location.id == this.selectedTakeoffLocationId;
        });
      }
      let lastForm = 0;
      if (selectedTakeoffLocation) {
        this.$store.dispatch(
          "saveSelectedShipperLocation",
          selectedTakeoffLocation
        );
        localStorage.setItem('shipperInfo', selectedTakeoffLocation)
        this.handleTakeoffActions(selectedTakeoffLocation);
        lastForm = 0;
      }
      this.loading = false;
      this.$store.dispatch("saveLastCompletedFormNo", lastForm);
      this.$router.push({ name: "NewBooking" });
    },
    handleTakeoffActions(location) {
      const shipper = { ...this.$store.getters.shipperInformation };
      delete shipper.userId;
      delete shipper.updatedAt;
      delete shipper.createdAt;
      delete shipper.id;
      this.$store.dispatch("saveBookingInformation", {
        property: "shipper",
        value: shipper,
      });
      this.$store.dispatch("saveTakeOffLocationId", location.id);
    },
    async searchLocation() {
      this.requestLoading = true;
      try {
        const response = await this.$_searchLocationByName(this.shipment);
        this.requestLoading = false;
        this.addresses = response.data.data.locations;
        if (this.addresses.length) {
          this.address = this.addresses[0];
        }
        this.log(response);
      } catch (error) {
        this.requestLoading = false;
        // this.handleError(error);
      }
    },
    disableButton() {
      if (this.shipment.length > 0) {
        return false;
      }
      return true;
    },
    closeModal() {
      this.$emit("close-modal");
    },
  },
  mounted() {
    let locations = this.$store.state.authentication.user.Org.locations
    let userAddress = locations.find(add => add.isDefault == true)

    if(!userAddress){
      userAddress = locations[0]
    }
    // console.log(userAddress)
    
    this.userAddress = {
      name:userAddress.address,
      lat: userAddress.lat,
      lng: userAddress.long
    }

    this.searchLocation();
  },
};
</script>

<style scoped>
.button {
  background: #fcc210;
  color: var(--primaryblue);
  width: 40%;
  font-weight: 500;
  /* margin-top: 3rem; */
}

.new-address-button {
  text-decoration-line: underline;

  color: #da9601;
}

.radio-label span::after {
  background: #bec4d5;
}
</style>
